module.exports = __webpack_public_path__ + "static/media/jcb.0c79e4c7.png";